<template>
  <p-container>
    <p-root-portal>
      <p-dialog v-if="vm.visibleDialog && vm.appSystemWebApi" :title="vm.visibleDialog === 'create' ? $t('core.page.appSystemWebApi.createOrUpdateWebApi.createTitle') : $t('core.page.appSystemWebApi.createOrUpdateWebApi.updateTitle')" @close="vm.closeDialog()">
        <template #content>
          <p-row column>
            <p-text-field v-model="vm.appSystemWebApi.apiUser" :label="$t('core.page.appSystemWebApi.list.apiUser')" required></p-text-field>
            <p-text-field v-model="vm.appSystemWebApi.apiUrl" :label="$t('core.page.appSystemWebApi.list.apiUrl')" required></p-text-field>
            <p-text-field v-model="vm.appSystemWebApi.apiPassword" type="password" :label="$t('core.page.appSystemWebApi.createOrUpdateWebApi.apiPassword')" required></p-text-field>
            <p-text-field v-model="vm.appSystemWebApi.apiAuthenticationType" :label="$t('core.page.appSystemWebApi.list.authType')" required></p-text-field>
            <p-number-field v-model.number="vm.appSystemWebApi.timeoutSeconds" :label="$t('core.page.appSystemWebApi.list.timeout')" required></p-number-field>
            <p-checkbox v-model="vm.appSystemWebApi.useProxy" :label="$t('core.page.appSystemWebApi.createOrUpdateWebApi.useProxy')"></p-checkbox>
            <p-text-field v-if="vm.appSystemWebApi.useProxy == true" v-model="vm.appSystemWebApi.proxyUrl" :label="$t('core.page.appSystemWebApi.list.proxyUrl')" required></p-text-field>
            <p-text-field v-if="vm.appSystemWebApi.useProxy == true" v-model="vm.appSystemWebApi.proxyUser" :label="$t('core.page.appSystemWebApi.list.proxyUser')" required></p-text-field>
            <p-text-field v-if="vm.appSystemWebApi.useProxy == true" v-model="vm.appSystemWebApi.proxyPassword" type="password" :label="$t('core.page.appSystemWebApi.createOrUpdateWebApi.proxyPassword')" required></p-text-field>
            <p-checkbox v-model="vm.appSystemWebApi.enableHttpsCertificateValidation" :label="$t('core.page.appSystemWebApi.list.enableHttpsCertificateValidation')"></p-checkbox>
            <p-text-field v-model="vm.appSystemWebApi.workspaceId" :label="$t('core.page.appSystemWebApi.list.workspaceId')"></p-text-field>
            <p-text-field v-model="vm.appSystemWebApi.secret" type="password" :label="$t('core.page.appSystemWebApi.createOrUpdateWebApi.secret')"></p-text-field>
            <p-button secondary class="mt-4" @click="vm.checkWebApiConnection()">
              {{ $t('core.page.appSystemWebApi.checkConnection.checkConnection') }}
            </p-button>
            <div>
              <p-alert :value="vm.webApiConnectionSuccessful != undefined" :type="vm.webApiConnectionSuccessful? 'success' : 'warning'">
                {{ vm.webApiConnectionResultMessage.title }}
                <ul v-if="vm.webApiConnectionResultMessage.detail">
                  <li>
                    {{ vm.webApiConnectionResultMessage.detail }}
                  </li>
                </ul>
              </p-alert>
            </div>
            <div>
              <p-request-alert v-model="vm.appSystemWebApiDataSource.error"></p-request-alert>
            </div>
          </p-row>
        </template>
        <template #actions>
          <p-button secondary @click="vm.closeDialog()">
            {{ $t('core.app.cancel') }}
          </p-button>
          <p-button @click="vm.createOrEditAppSystemWebApi()">
            {{ $t('core.app.save') }}
          </p-button>
        </template>
      </p-dialog>
    </p-root-portal>
    <div v-if="vm.appSystem.data">
      <p-row align-center>
        <p-button tertiary @click="$router.back()">
          <p-icon>
            keyboard_backspace
          </p-icon>
        </p-button>
        <h2 class="mb-4">
          App System WebApis: {{ vm.appSystem.data.name }}
        </h2>
      </p-row>
    </div>
    <p-card v-if="vm.appSystem.data" class="mb-4">
      <p-row column dense>
        <span>TenantKey: {{ vm.appSystem.data.tenantKey }}</span>
        <span>IsActive: {{ vm.appSystem.data.isActive }}</span>
      </p-row>
    </p-card>
    <p-request-alert v-model="vm.appSystemWebApiDataSource.error"></p-request-alert>
    <div v-if="vm.appSystemWebApiDataSource.data">
      <p-card>
        <p-surface layer="2" class="pl-2 mb-2">
          <p-row align-center>
            <p-col shrink>
              <p-button @click="vm.appSystemWebApiDataSource.select()">
                <p-icon dense>
                  refresh
                </p-icon>
              </p-button>
              <p-button @click="vm.showCreateDialog()">
                {{ $t('core.page.appSystemWebApi.action.newWebApi') }}
              </p-button>
            </p-col>
          </p-row>
        </p-surface>
        <p-table v-if="vm.appSystemWebApiDataSource.data" class="appSystemWebApiList">
          <template #rows>
            <tr>
              <th>{{ $t('core.page.appSystemWebApi.list.apiUser') }}</th>
              <th>{{ $t('core.page.appSystemWebApi.list.apiUrl') }}</th>
              <th>{{ $t('core.page.appSystemWebApi.list.authType') }}</th>
              <th>{{ $t('core.page.appSystemWebApi.list.timeout') }}</th>
              <th>{{ $t('core.page.appSystemWebApi.list.proxyUser') }}</th>
              <th>{{ $t('core.page.appSystemWebApi.list.proxyUrl') }}</th>
              <th>{{ $t('core.page.appSystemWebApi.list.enableHttpsCertificateValidation') }}</th>
              <th>{{ $t('core.page.appSystemWebApi.list.workspaceId') }}</th>
              <th></th>
            </tr>
            <tr v-for="appSystemWebApi in vm.appSystemWebApiDataSource.data.items" :key="appSystemWebApi.data.id">
              <td>
                {{ appSystemWebApi.data.apiUser }}
              </td>
              <td>
                {{ appSystemWebApi.data.apiUrl }}
              </td>
              <td>
                {{ appSystemWebApi.data.apiAuthenticationType }}
              </td>
              <td>
                {{ appSystemWebApi.data.timeoutSeconds }}
              </td>
              <td>
                {{ appSystemWebApi.data.proxyUser }}
              </td>
              <td>
                {{ appSystemWebApi.data.proxyUrl }}
              </td>
              <td>
                {{ appSystemWebApi.data.enableHttpsCertificateValidation }}
              </td>
              <td>
                {{ appSystemWebApi.data.workspaceId }}
              </td>
              <td>
                <p-row nowrap align-center justify-end dense>
                  <p-button
                    :disabled="vm.appSystemWebApiDataSource.isLoading"
                    dense
                    @click="vm.showEditDialog(appSystemWebApi.data)"
                  >
                    <p-icon dense>
                      edit
                    </p-icon>
                  </p-button>
                  <p-button
                    :disabled="vm.appSystemWebApiDataSource.isLoading"
                    dense
                    secondary
                    @click="vm.onDeleteClick(appSystemWebApi)"
                  >
                    <p-icon dense color="error">
                      delete
                    </p-icon>
                  </p-button>
                </p-row>
              </td>
            </tr>
          </template>
        </p-table>
        <p-pagination v-model="vm.appSystemWebApiDataSource.paging"></p-pagination>
      </p-card>
    </div>
  </p-container>
</template>

<script lang="ts">
  import Vue from 'vue';
  import AppSystemWebApiViewModel from './list.vue.model';

  export default Vue.extend({
    auth: true,
    role: ['admin', 'hostadmin'],
    layout: 'layout-hostadmin',
    data: () => ({
      vm: new AppSystemWebApiViewModel(),
    }),
    mounted() {
      this.vm.initialize();
    },
  });
</script>
